import { styled, Switch as MuiSwitch, SwitchProps } from '@mui/material';

interface CustomSwitchProps extends Omit<SwitchProps, 'size'> {
  size?: 'default' | 'large';
}

export const Switch = styled((props: CustomSwitchProps) => {
  const { size = 'default', ...otherProps } = props;
  return <MuiSwitch focusVisibleClassName=".Mui-focusVisible" disableRipple {...otherProps} />;
})<CustomSwitchProps>(({ size = 'default' }) => {
  const dimensions = {
    default: {
      width: 36,
      height: 20,
      thumbSize: 16,
      translateX: 16,
      margin: 2,
    },
    large: {
      width: 44,
      height: 24,
      thumbSize: 20,
      translateX: 20,
      margin: 2,
    },
  };

  const { width, height, thumbSize, translateX, margin } = dimensions[size];

  return {
    width,
    height,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: `translateX(${translateX}px)`,
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#2055FF',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#2055FF',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: '#f5f5f5',
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: thumbSize,
      height: thumbSize,
    },
    '& .MuiSwitch-track': {
      borderRadius: height / 2,
      backgroundColor: '#E9E9EA',
      opacity: 1,
      transition: 'background-color 500ms',
    },
  };
});
